<template>
  <div class="realdetile">
    <div style="display:flex;margin-top:10px">
      <div style="flex:1">
        <el-button type="primary" icon="el-icon-search" @click='searchdevice'>{{ $t('realdetile.filterAir')
          }}</el-button>
      </div>
      <el-button type="primary" icon="el-icon-back" @click='goblack'>{{ $t('realdetile.return') }}</el-button>
    </div>

    <div class="con">
      <div class="content">
        <div class="real_top">
          <div class='acinfo'>
            <div class="info_top"><span>{{ $t('realdetile.eleInfo') }}</span></div>
            <div class="info_bot">
              <div class="bot_list bot_list1">
                <div>{{ $t('manipulation.devName') }}：</div>
                <div style="flex:4">{{ realinfo.projectName }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('manipulation.deviceAdressNum') }}：</div>
                <div style="flex:3">{{ realinfo.devCodeDec }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('manipulation.airNum') }}：</div>
                <div style="flex:2">{{ realinfo.devNumber }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('manipulation.buildNum') }}：</div>
                <div style="flex:3">{{ realinfo.towerNumber }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('manipulation.ladderNum') }}：</div>
                <div style="flex:3">{{ realinfo.stairsNumber }}</div>
              </div>

              <div class="bot_list">
                <div>{{ $t('manipulation.airModel') }}：</div>
                <div style="flex:3">{{ realinfo.devModelName }}</div>
              </div>

              <div class="bot_list">
                <div>{{ $t('manipulation.comStatus') }}：</div>
                <div style="flex:3">{{ realinfo.onlineFlag }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('manipulation.workStatus') }}：</div>
                <div style="flex:3">{{ realinfo.workStatus }}</div>
              </div>
              <div class="bot_list">
                <div>{{ $t('realdetile.operaStatus') }}：</div>
                <div style="flex:3">{{ realinfo.runStatus }}</div>
              </div>
              <div class="bot_list bot_list1">
                <div>{{ $t('manipulation.installAddress') }}：</div>
                <div style="flex:4">{{ realinfo.address }}</div>
              </div>
              <!-- <div class="bot_list">
                                    <div style="flex:2">空调地址：</div>
                                    <div style="flex:3">{{realinfo.ktdz}}</div>
                                </div> -->
            </div>
          </div>
          <div class="fault_info">
            <div class="info_top"><span>{{ $t('realdetile.faultInfo') }}</span></div>
            <div class="fault_bot" style="max-height: 230px;overflow: auto;">
              <div class="bot_list" v-for='(item, index) in faultlist' :key='index'>
                <div style="flex:3" class="tit">{{ item.monitorName }}</div>
                <div style="flex:3">{{ item.isgz ? item.monitorValue : $t('alarmData.fail') }}</div>
              </div>
              <!-- <div class="bot_list" v-for='(item,index) in testlist' :key='index' v-if="fun(`faultGZ${item}`).monitorValue">

                                        <div class="tit" style="flex:3">{{fun(`faultGZ${item}`).monitorName}}</div>
                                        <div style="flex:3;" >{{fun(`faultGZ${item}`).monitorValue}}</div>
                                </div> -->
              <div class="bot_list" v-for='(item, index) in testlistVal' :key='index' v-if="item.monitorValue">

                <div class="tit" style="flex:3">{{ item.monitorName }}</div>
                <el-tooltip effect="dark" :content="item.monitorValue" placement="top">
                  <div style="flex:3;overflow: hidden;" class="overhid">{{ item.monitorValue }}</div>
                </el-tooltip>

              </div>


            </div>
          </div>
        </div>
        <div class="real_top">
          <div class='acinfo'>
            <div class="info_top"><span>{{ $t('realdetile.infoPara') }}</span></div>
            <div class="ac_bot" style="display:flex">
              <div style="flex:1;margin-right:4.5%">
                <div class="fault_bot">
                  <div class="bot_list" v-for='(item, index) in temlist' :key=index>
                    <div style="flex:3" class="tit">{{ item.monitorName }}</div>
                    <div style="flex:3">{{ item.monitorValue }} {{ item.monitorValue && item.monitorValue != '--' ?
          item.unit : '' }}
                    </div>
                  </div>
                </div>
                <!-- <div class="water">
                                           <span> 水位指示：</span>
                                            <div style="width:80%">
                                                <el-progress :percentage="percentage" :stroke-width="25" :color="customColors"></el-progress>
                                            </div>
                                    </div> -->
                <div class="water1" v-if="waterAvailable">
                  <span style="margin-right: 5px;"> {{ $t('realdetile.water') }}</span>
                  <div class="wa_list" style="width:80%">
                    <span :class="item.val == 1 ? span1 : (item.val == 2 ? 'bla' : '')"
                      v-for="(item, index) in proglist" :key='index'>
                      {{ item.name }}%
                    </span>

                  </div>
                  <p> {{ percentage }} %</p>
                </div>
                <div class="water1" v-else>
                  <span style="margin-right: 5px;"> {{ $t('realdetile.water') }}</span>
                  <p>{{ $t('manipulation.unreported') }}</p>
                </div>
              </div>
              <div style="flex:1">
                <div class="fault_bot">
                  <div class="bot_list" v-for='(item, index) in acinfoList' :key='index'>
                    <div style="flex:3" class="tit">{{ item.name }}</div>
                    <div style="flex:3">
                      <el-switch v-model="item.value" disabled active-value="1" inactive-value="0">
                      </el-switch>
                    </div>
                  </div>
                  <div class="bot_list">
                    <div style="flex:3" class="tit">{{ $t('manipulation.sleepMode') }}</div>
                    <div style="flex:3">
                      <el-switch v-model="dormancyval" disabled active-value="1" inactive-value="0">
                      </el-switch>
                    </div>
                  </div>
                  <div class="bot_list">
                    <div style="flex:3" class="tit">{{ $t('realdetile.delayOff') }}</div>
                    <div style="flex:3">
                      <el-switch v-model="delayval" disabled active-value="1" inactive-value="0">
                      </el-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fault_info">

            <div class="info_top"><span>{{ $t('realdetile.setPara') }}</span></div>
            <div class="fault_bot" v-if="realinfo.runStatus == `${$t('manipulation.manual')}`">
              <div class="bot_list"
                v-if="setuplist[2] && setuplist[2].monitorValue != `${$t('manipulation.auto')}` && setuplist[2].monitorValue != `${$t('manipulation.wind')}`">
                <div style="flex:3" class="tit">{{ setuplist[0].monitorName }}</div>
                <div style="flex:3">{{ setuplist[0].monitorValue }}</div>
              </div>
              <div class="bot_list" v-for='(item, index) in setuplist' :key='index' v-if="index > 0">
                <div style="flex:3" class="tit">{{ item.monitorName }}</div>
                <div style="flex:3">{{ item.monitorValue }}</div>
              </div>
            </div>
            <div class="fault_bot" v-if="realinfo.runStatus == `${$t('manipulation.timing')}`">
              <div class="bot_list">
                <div style="flex:3" class="tit">{{ $t('realdetile.operaStatus') }}</div>
                <div style="flex:3">{{ $t('manipulation.timing') }}</div>
              </div>
              <div class="bot_list">
                <div style="flex:3" class="tit">{{ $t('realdetile.modelDetail') }}</div>
                <div style="flex:3"><el-button type="primary" @click='lookdev'>{{ $t('realdetile.view') }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="dialogBox" :title="$t('realdetile.choAir')" :visible.sync="fileVisible" width="50%"
      :before-close='beforeClose' center>
      <div class="searchinfo">
        <span>{{ $t('manipulation.airNum') }}：</span>
        <el-input v-model.trim="devNumber" clearable :placeholder="$t('realdetile.pleInputAirCode')"
          class="handle-input " style="width:160px"></el-input>
        <el-button type="primary" icon="el-icon-search">{{ $t('realdetile.search') }}</el-button>
      </div>
      <div>
        <el-table :data="devicelist" style="width: 100%">
          <el-table-column v-for="(item, index) in column" :prop="item.prop" :label="item.label" align="center"
            :key="index" :width="item.width">
          </el-table-column>
          <el-table-column :label="$t('realdetile.opera')" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="primary" @click="changedevice(scope.row)">{{ $t('manipulation.sure') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagi">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="page.current" :page-size="10"
            layout="total, prev, pager, next" :total="totals">
          </el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer flex row vertical-center">
      </div>
    </el-dialog>
    <Parmodel :dialogStationVisible='dialogStationVisible' :title='title' @closepar='closepar' ref='parmodel' />
  </div>
</template>

<script>

import Parmodel from './parmodel'
import { devMonitorList, multiplecurrent, getDeviceListById } from "@/api/devicemon";
import { sendSock, initWebSocket, websocketclose } from '@/util/socket.js';
import { createRealtimeMetricRows, mergeRealtimeMetric, hasMonitorValue, formatRunStatus, formatBinaryStatus, isCurrentRequest } from '@/util/monitorMetrics';
export default {
  name: 'realdetile',
  components: {
    Parmodel
  },
  data() {
    return {
      delayval: '',
      dormancyval: '',
      title: this.$t('realdetile.timeModeView'),
      dialogStationVisible: false,
      arr: [
        1, 2, 3, 4, 5, 6, 7, 8, 9
      ],
      fileVisible: false,
      realinfo: {},
      acinfoList: [],
      temlist: [],
      setuplist: [],
      faultlist: [],
      percentage: 0,
      waterAvailable: false,
      currentDataRequestId: 0,
      currentDeviceContext: { onenetId: '', devCode: '' },
      fault: [
        { name: this.$t('realdetile.eleTem'), streamId: '05', unit: '°C' },
        { name: this.$t('realdetile.waterLevel'), streamId: '06', unit: '%' },
        { name: this.$t('realdetile.suVoltage'), streamId: '07', unit: 'V' },
        { name: this.$t('realdetile.totalCurrent'), streamId: '08', unit: 'A' },
        { name: this.$t('realdetile.coilTemp'), streamId: '09', unit: '°C' },
        { name: this.$t('realdetile.windTem'), streamId: '0A', unit: '°C' },
      ],

      faultGZ05: { monitorName: '', monitorValue: '' },
      faultGZ06: { monitorName: '', monitorValue: '' },
      faultGZ07: { monitorName: '', monitorValue: '' },
      faultGZ08: { monitorName: '', monitorValue: '' },
      faultGZ09: { monitorName: '', monitorValue: '' },
      faultGZ0A: { monitorName: '', monitorValue: '' },
      faultGZ00: 100,
      testlist: ['05', '06', '07', '08', '09', '0A'],
      testlistVal: [],
      customColors: [
        { color: '#5cb87a', percentage: 51 },
        { color: '#e6a23c', percentage: 81 },
        { color: '#f56c6c', percentage: 100 },
      ],
      devicelist: [],
      parantval: '',
      column: [
        { prop: 'devNumber', label: this.$t('manipulation.airNum') },
        { prop: 'devModelName', label: this.$t('manipulation.airModel') },
        { prop: 'onlineFlag1', label: this.$t('manipulation.comStatus') },
        { prop: 'workStatus1', label: this.$t('manipulation.workStatus') },
        { prop: 'runStatus1', label: this.$t('realdetile.operaStatus') },
      ],
      currentPage1: 1,
      totals: 0,
      page: {
        current: 1,
        size: 10
      },
      devNumber: '',
      wayinfo: '',
      patoptions: [this.$t('manipulation.auto'), this.$t('realdetile.heating'), this.$t('realdetile.refrigeration'), this.$t('manipulation.wind')],
      proglist: [{ name: '20', val: '0' }, { name: '50', val: '0' }, { name: '80', val: '0' }, { name: '100', val: '0' }],
      progval: 0,
      progoldval: 0,
      span1: ''
    }
  },
  watch: {
    progval(val) {
      if (val == 1) {
        this.span1 = 'gr'
      } else if (val == 2) {
        this.span1 = 'gr'
      } else if (val == 3) {
        this.span1 = 'ye'
      } else if (val == 4) {
        this.span1 = 're'
      }
    }
  },
  created() {
    // this.getdevMonitorList()
    // this.changeproglist(4,0)
  },
  methods: {
    changeproglist(val, newval, num) {
      console.log(val, newval)
      let res = this.proglist
      if (val > newval) {
        res.map((item, index) => {
          if (index < newval) {
            item.val = 1
          } else {
            item.val = 0
          }
          num && num.map(v => {
            if (v == item.name) {
              item.val = 2
            }
          })

        })
      } else {
        res.map((item, index) => {
          if (index >= val && index < newval) {
            item.val = 1
          } else if (index < val) {
            item.val = 1
          } else {
            item.val = 0
          }
          num && num.map(v => {
            if (v == item.name) {
              item.val = 2
            }
          })
        })
      }


    },
    // 将字符串转换成变量
    fun(text) {
      return eval(this[`${text}`]); //这样写字符串就可以当做变量使用，否则会返回字符串
    },
    lookdev() {
      this.dialogStationVisible = true
      this.$nextTick(() => {
        this.$refs.parmodel.getallinfo([this.wayinfo])
      })
    },
    closepar() {
      this.dialogStationVisible = false
    },

    getsocket(requestId = this.currentDataRequestId, requestContext = this.currentDeviceContext) {
      let streamIds = ['00', '04', '05', '0A', '09', '07', '08', '12', '14', '13', '0B', '06', '11', 'GZ05', 'GZ06', 'GZ07', 'GZ08', 'GZ09', 'GZ0A', 'GJ06', 'GJ07', 'GJ08']
      streamIds.map((item, index) => {
        let res = this.wayinfo.onenetId + this.wayinfo.devCode + item

        initWebSocket(`wss://heshanprod.thingcom.com/ws?type=4&topic=${res}`, index)
        sendSock('', index, (res) => {
          if (!isCurrentRequest(requestId, this.currentDataRequestId, requestContext, this.currentDeviceContext)) {
            return
          }
          console.log(res)
          let str = res.target.url
          let obj = str.substring(str.length - 2)
          let obj1 = str.substring(str.length - 4)
          let objData = ''

          if (obj1.indexOf('GZ') != -1 || obj1.indexOf('GJ') != -1) {
            if (res.data === null || res.data === undefined || res.data === '') {
              return
            }
            let gjname = String(res.data).split(":")
            let obj2 = {
              monitorName: gjname[0],
              monitorValue: obj1 === 'GZ06' ? gjname[1] + gjname[2] + gjname[3] : gjname[1],
              streamId: obj1
            }
            let result = this.testlistVal.filter(v => v.streamId === obj1)
            if (this.testlistVal.length > 0 && result.length > 0) {
              this.testlistVal.map((v, i) => {
                if (v.streamId === result[0].streamId) {

                  this.$set(this.testlistVal, i, obj2)
                }
              })
            } else {
              this.testlistVal.push(obj2)
            }

            let cList = [{ name: '0', id: 0 }, { name: '20', id: 1 }, { name: '50', id: 2 }, { name: '80', id: 3 }, { name: '100', id: 4 }]
            if (obj1 === 'GZ06' && res.data !== null && res.data !== undefined && res.data !== '') {

              let r = String(res.data).split(':')
              let att = []

              r[2].split(',')[0].split('~').map(t => {
                cList.map(v => {
                  if (v.name == Number(t)) {
                    att.push(v.id)
                  }
                })
              })

              this.changeproglist(att[0], att[1], r[3].split(','))
            }
          }
          if (obj === '00' && obj1.indexOf('G') == -1) {
            this.realinfo.ktdz = res.data
            this.$forceUpdate()
          }
          if (obj === '04' && hasMonitorValue({ monitorValue: res.data })) {
            let arr1 = [
              { name: this.$t('realdetile.on') + '/' + this.$t('realdetile.off') }, { name: this.$t('realdetile.defrosting') }, { name: this.$t('alarmData.fail') }, { name: this.$t('realdetile.highWindStatus') }, { name: this.$t('realdetile.lowWindStatus') }, { name: this.$t('realdetile.waterPumpStatus') }, { name: this.$t('realdetile.heatStatus') },
              { name: this.$t('realdetile.paStatus') }]
            let arr = String(res.data).split('')
            arr.map((v, i) => {
              arr1[i].value = v
            })
            this.realinfo.workStatus = formatBinaryStatus(arr1[0].value, {
              zero: this.$t('realtimeinfo.turnOff'),
              one: this.$t('realtimeinfo.powerOn'),
              unreported: this.$t('manipulation.unreported')
            })
            let arr6 = []
            arr1.map((item, index) => {
              if (index != 1 && index != 2) {
                arr6.push(item)
              }
            })
            this.acinfoList = arr6
          }
          if (obj === '05') {
            this.temlist[0].monitorValue = res.data

          }
          if (obj === '0A') {
            this.temlist[1].monitorValue = res.data

          }
          if (obj === '09') {
            this.temlist[2].monitorValue = res.data
          }
          if (obj === '07' && obj1.indexOf('G') == -1) {
            this.temlist[3].monitorValue = res.data
          }
          if (obj === '08' && obj1.indexOf('G') == -1) {
            this.temlist[4].monitorValue = res.data
          }
          if (obj === '12' && hasMonitorValue({ monitorValue: res.data })) {
            let unit = '°C'
            let temperatureItem = this.setuplist.find(item => item.streamId === '12')
            if (temperatureItem) {
              temperatureItem.monitorValue = res.data + unit
            }
          }
          if (obj === '14' && res.data !== null && res.data !== undefined && res.data !== '') {
            let runStatusItem = this.setuplist.find(item => item.streamId === '14')
            if (runStatusItem) {
              runStatusItem.monitorValue = formatRunStatus(res.data, {
                manual: this.$t('manipulation.manual'),
                timing: this.$t('manipulation.timing'),
                unreported: this.$t('manipulation.unreported')
              })
            }
            this.realinfo.runStatus = formatRunStatus(res.data, {
              manual: this.$t('manipulation.manual'),
              timing: this.$t('manipulation.timing'),
              unreported: this.$t('manipulation.unreported')
            })
          }
          if (obj === '13' && hasMonitorValue({ monitorValue: res.data })) {
            let a = String(res.data).split('')
            let mname = ''
            if (a[7] === '0') {
              if (a[6] === '0') {
                mname = this.$t('manipulation.auto')
              } else {
                mname = this.$t('realdetile.refrigeration')
              }
            } else {
              if (a[6] === '0') {
                mname = this.$t('realdetile.heating')
              } else {
                mname = this.$t('manipulation.wind')
              }
            }
            let modeItem = this.setuplist.find(item => item.streamId === '13-mode')
            let windItem = this.setuplist.find(item => item.streamId === '13-wind')
            if (modeItem) {
              modeItem.monitorValue = mname
            }
            if (windItem) {
              windItem.monitorValue = a[2] === '1' ? this.$t('realdetile.highWind') : this.$t('realdetile.lowWind')
            }
            this.$forceUpdate()
          }
          if (obj === '0B' && hasMonitorValue({ monitorValue: res.data })) {
            let a = String(res.data).split('')
            let arr4 = [{ monitorName: this.$t('realdetile.eleTemFail'), id: '05' }, { monitorName: this.$t('realdetile.windTemFail'), id: '0A' }, { monitorName: this.$t('realdetile.coilTemFail'), id: '09' }]
            let arr5 = []
            a.map((v, i) => {
              if (i < 3) {
                arr4[i].monitorValue = v
              }
            })
            arr4.map((v, i) => {
              if (v.monitorName && v.monitorValue == '1') {
                arr5.push(v)
                this.temlist[i].monitorValue = '--'
              }
            })
            this.faultlist = arr5
          }
          if (obj === '11' && hasMonitorValue({ monitorValue: res.data })) {
            let a = String(res.data).split("")
            this.dormancyval = a[1]
          }
          if (obj === '06' && obj1.indexOf('G') == -1 && hasMonitorValue({ monitorValue: res.data })) {
            this.waterAvailable = true
            let a = String(res.data).split('')
            let b = []
            a.map((v) => {
              b.unshift(v)
            })
            let num = 0
            let ii = 0

            b.map((v, i) => {
              if (b[i] === '1' && i < 4) {
                if (i === 2) {
                  this.percentage = 80
                } else if (i === 0) {
                  this.percentage = 20
                } else {
                  this.percentage = 25 * (i + 1)
                }
                ii = i + 1
                num = num + v
              }
              if (i === 6) {

                this.delayval = v
              }
            })

            if (!num) {
              this.percentage = 0

              this.changeproglist(0, 0)
              this.progval = 0

            } else {

              this.changeproglist(ii - 1, ii)
              this.progval = ii

            }
            const requestId = this.currentDataRequestId
            const requestContext = this.currentDeviceContext
            setTimeout(() => {
              this.getmultip(requestId, requestContext)
            }, 2000)
          }


        })
      })
    },
    closesocket() {
      let a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
      a.map((item, index) => {
        websocketclose(index)
      })
    },
    getdevicelist(data) {
      getDeviceListById({ id: data.id, ...this.page }).then(res => {

        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
            item.workStatus1 = formatBinaryStatus(item.workStatus, {
              zero: this.$t('realtimeinfo.turnOff'),
              one: this.$t('realtimeinfo.powerOn'),
              unreported: this.$t('manipulation.unreported')
            })
            item.runStatus1 = formatRunStatus(item.runStatus, {
              manual: this.$t('manipulation.manual'),
              timing: this.$t('manipulation.timing'),
              unreported: this.$t('manipulation.unreported')
            })
            item.onlineFlag1 = formatBinaryStatus(item.onlineFlag, {
              zero: this.$t('realtimeinfo.offLine'),
              one: this.$t('realtimeinfo.onLine'),
              unreported: this.$t('manipulation.unreported')
            })
          })
          this.devicelist = res.data.data.records
          this.totals = res.data.data.total
          this.page.current = res.data.data.current
        }
      })
    },
    // 切换分页
    handleCurrentChange(val) {
      this.page.current = val
      this.getdevicelist(this.parantval)
    },

    getinfo(val, parantval) {

      let res = JSON.parse(JSON.stringify(val))
      const requestId = ++this.currentDataRequestId
      const requestContext = { onenetId: res.onenetId, devCode: res.devCode }
      this.currentDeviceContext = requestContext
      this.wayinfo = res
      this.parantval = JSON.parse(JSON.stringify(parantval))
      this.realinfo = {
        towerNumber: res.towerNumber,
        projectName: parantval.projectName,
        devNumber: res.devNumber,
        devCode: res.devCode,
        devCodeDec: res.devCodeDec,
        address: parantval.address,
        devModelName: res.devModelName,
        stairsNumber: res.stairsNumber,
        onlineFlag: formatBinaryStatus(res.onlineFlag, {
          zero: this.$t('realtimeinfo.offLine'),
          one: this.$t('realtimeinfo.onLine'),
          unreported: this.$t('manipulation.unreported')
        }),
        runStatus: formatRunStatus(res.runStatus, {
          manual: this.$t('manipulation.manual'),
          timing: this.$t('manipulation.timing'),
          unreported: this.$t('manipulation.unreported')
        }),
        workStatus: formatBinaryStatus(res.workStatus, {
          zero: this.$t('realtimeinfo.turnOff'),
          one: this.$t('realtimeinfo.powerOn'),
          unreported: this.$t('manipulation.unreported')
        }),

      }
      this.closesocket()
      this.getsocket(requestId, requestContext)
      this.getmultiplecurrent(res, requestId, requestContext)

    },
    // 查询水位故障信息
    getmultip(requestId = this.currentDataRequestId, requestContext = this.currentDeviceContext) {
      let obj = {
        streamIds: "06",
        devCode: this.wayinfo.devCode,
        onenetId: this.wayinfo.onenetId
      }
      multiplecurrent(obj).then(res => {
        if (!isCurrentRequest(requestId, this.currentDataRequestId, requestContext, this.currentDeviceContext)) {
          return
        }
        if (res.data.code == 200) {
          const currentData = Array.isArray(res.data.data) ? res.data.data.filter(item => item && item.streamId) : []

          let result = currentData.filter(v => v.streamId === 'GZ06')
          if (result.length < 1) {

            this.testlistVal.map((item, index) => {
              if (item.streamId === 'GZ06') {
                this.testlistVal.splice(index, 1)
              }
            })
          }
        }
      }).catch(() => {})
    },
    // 获取监控点数据
    getmultiplecurrent(info, requestId = this.currentDataRequestId, requestContext = this.currentDeviceContext) {

      let obj = {
        streamIds: "00,04,05,0A,09,07,08,12,14,13,0B,06,11",
        devCode: info.devCode,
        onenetId: info.onenetId

      }
      this.realinfo.runStatus = this.$t('manipulation.unreported')
      this.waterAvailable = false
      this.delayval = ''
      this.dormancyval = ''
      this.percentage = 0
      multiplecurrent(obj).then(res => {
        if (!isCurrentRequest(requestId, this.currentDataRequestId, requestContext, this.currentDeviceContext)) {
          return
        }
        if (res.data.code == 200) {
          let arr1 = [
            { name: this.$t('realdetile.on') + '/' + this.$t('realdetile.off') }, { name: this.$t('realdetile.defrosting') }, { name: this.$t('alarmData.fail') }, { name: this.$t('realdetile.highWindStatus') }, { name: this.$t('realdetile.lowWindStatus') }, { name: this.$t('realdetile.waterPumpStatus') }, { name: this.$t('realdetile.heatStatus') },
            { name: this.$t('realdetile.paStatus') }]
          let arr2 = createRealtimeMetricRows({
            temperature: this.$t('realdetile.eleTem'),
            windTemperature: this.$t('realdetile.windTem'),
            coilTemperature: this.$t('realdetile.coilTemp'),
            voltage: this.$t('realdetile.suVoltage'),
            current: this.$t('realdetile.totalCurrent')
          })
          let arr3 = []
          let arr4 = [{ monitorName: this.$t('realdetile.eleTemFail'), id: '05' }, { monitorName: this.$t('realdetile.windTemFail'), id: '0A' }, { monitorName: this.$t('realdetile.coilTemFail'), id: '09' }]
          let arr5 = []
          const currentData = Array.isArray(res.data.data) ? res.data.data.filter(item => item && item.streamId) : []
          currentData.map(item => {

            if (item.streamId === '00') {
              this.realinfo.ktdz = item.monitorValue
              this.$forceUpdate()
            }
            if (item.streamId === '04' && hasMonitorValue(item)) {
              let arr = String(item.monitorValue).split('')
              arr.map((v, i) => {
                arr1[i].value = v
              })
            }
            mergeRealtimeMetric(arr2, item)

            if (item.streamId === '13' && hasMonitorValue(item)) {
              let a = item.monitorValue.split('')
              let mname = ''
              if (a[7] === '0') {
                if (a[6] === '0') {
                  mname = this.$t('manipulation.auto')
                } else {
                  mname = this.$t('realdetile.refrigeration')
                }
              } else {
                if (a[6] === '0') {
                  mname = this.$t('realdetile.heating')
                } else {
                  mname = this.$t('realdetile.wind')
                }
              }
              arr3.push({
                streamId: '13-mode',
                monitorName: this.$t('manipulation.operaMode'),
                monitorValue: mname
              }, {
                streamId: '13-wind',
                monitorName: this.$t('realdetile.setwindSpeed'),
                monitorValue: a[2] === '1' ? this.$t('realdetile.highWind') : this.$t('realdetile.lowWind')
              })

            } else if (item.streamId === '13') {
              arr3.push({
                streamId: '13-mode',
                monitorName: this.$t('manipulation.operaMode'),
                monitorValue: this.$t('manipulation.unreported')
              }, {
                streamId: '13-wind',
                monitorName: this.$t('realdetile.setwindSpeed'),
                monitorValue: this.$t('manipulation.unreported')
              })
            }
            if (item.streamId === '12') {
              arr3.push({
                streamId: '12',
                monitorName: item.monitorName,
                monitorValue: hasMonitorValue(item) ? item.monitorValue + '°C' : this.$t('manipulation.unreported')
              })
            }
            if (item.streamId === '14') {
              arr3.push({
                streamId: '14',
                monitorName: item.monitorName,
                monitorValue: formatRunStatus(item.monitorValue, {
                  manual: this.$t('manipulation.manual'),
                  timing: this.$t('manipulation.timing'),
                  unreported: this.$t('manipulation.unreported')
                })
              })
              if (hasMonitorValue(item)) {
                this.realinfo.runStatus = formatRunStatus(item.monitorValue, {
                  manual: this.$t('manipulation.manual'),
                  timing: this.$t('manipulation.timing'),
                  unreported: this.$t('manipulation.unreported')
                })
              } else {
                this.realinfo.runStatus = this.$t('manipulation.unreported')
              }
            }
            if (item.streamId === '0B' && hasMonitorValue(item)) {
              let a = String(item.monitorValue).split('')
              a.map((v, i) => {
                if (i < 3) {
                  arr4[i].monitorValue = v
                }
              })
              arr4.map(v => {
                if (v.monitorName && v.monitorValue === '1') {
                  arr5.push(v)
                  arr2.map((t) => {
                    if (t.streamId === v.id) {
                      t.monitorValue = "--"
                    }
                  })
                }
              })

            }
            if (item.streamId.indexOf('GZ') != -1 || item.streamId.indexOf('GJ') != -1) {
              let obj = {
                monitorName: item.monitorName,
                monitorValue: item.monitorValue,
                streamId: item.streamId
              }
              let result = this.testlistVal.filter(v => v.streamId === item.streamId)
              if (this.testlistVal.length > 0 && result.length > 0) {
                this.testlistVal.map((v, i) => {
                  if (v.streamId === result[0].streamId) {
                    v = obj
                  }
                })
              } else {
                this.testlistVal.push(obj)
              }
              // this[`fault${item.streamId}`] = {monitorName:item.monitorName+'故障',monitorValue:item.monitorValue?item.monitorValue:item.alarmRankName}
              let cList = [{ name: '0', id: 0 }, { name: '20', id: 1 }, { name: '50', id: 2 }, { name: '80', id: 3 }, { name: '100', id: 4 }]
              if (item.streamId === 'GZ06' && hasMonitorValue(item)) {
                console.log(item.monitorValue)

                let r = String(item.monitorValue).split(':')
                let att = []

                r[1].split(',')[0].split('~').map(t => {
                  cList.map(v => {
                    if (v.name == Number(t)) {
                      att.push(v.id)
                    }
                  })
                })

                this.changeproglist(att[0], att[1], r[2].split(','))
              }
            }
            if (item.streamId === '11' && hasMonitorValue(item)) {
              let a = item.monitorValue.split("")
              this.dormancyval = a[1]
            }
            if (item.streamId === '06' && hasMonitorValue(item)) {
              this.waterAvailable = true
              let a = item.monitorValue.split("")
              let b = []
              a.map((v) => {
                b.unshift(v)
              })

              b.map((v, i) => {
                if (b[i] === '1' && i < 4) {
                  if (i === 2) {
                    this.percentage = 80
                  } else if (i === 0) {
                    this.percentage = 20
                  } else {
                    this.percentage = 25 * (i + 1)
                  }
                  this.changeproglist(i, i + 1)
                  this.progval = i + 1

                }
                if (i === 6) {

                  this.delayval = v
                }
              })
            }
          })
          let arr6 = []
          arr1.map((item, index) => {
            if (index != 1 && index != 2) {
              arr6.push(item)
            }
          })
          this.temlist = arr2
          this.acinfoList = arr6


          this.setuplist = arr3
          this.faultlist = arr5
        }
      }).catch(() => {})
    },
    //切换空调
    changedevice(info) {

      this.fileVisible = false
      this.getinfo(info, this.parantval)
    },
    goblack() {
      this.currentDataRequestId += 1
      this.currentDeviceContext = { onenetId: '', devCode: '' }
      this.closesocket()
      this.$emit('goblack')
    },
    beforeClose() {
      this.fileVisible = false
    },
    searchdevice() {
      this.getdevicelist(this.parantval)
      this.fileVisible = true
    }
  }
}
</script>
<style lang='scss'>
.realdetile {
  padding: 5px 10px;

  .content {
    flex: 1;

    .overhid {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }

    .real_top {
      display: flex;
      margin-bottom: 20px;

      .acinfo {
        flex: 2;
        margin-right: 3%;
        min-height: 200px;

        .info_bot {
          background: #F2FBFB;
          display: flex;
          flex-wrap: wrap;
          padding: 1%;

          .bot_list {
            display: flex;
            width: 25%;
            margin-bottom: 15px;

            div {
              font-size: 14px;
            }
          }

          .bot_list1 {
            width: 50%;
          }
        }
      }

      .water {
        display: flex;
        margin-top: 50px;

        .el-progress__text {
          font-size: 19px !important;
          margin-left: 8px
        }

        // height: 10px;
        // background-color: #ccc;
        // display: flex;
        // border-radius: 5px;

        // span{
        //     flex:1;
        //     border-radius: 5px;

        // }
        // .span2{
        //     background: blue;
        // }
        // .span3{
        //     background: blue;
        // }
        // .span4{
        //     background: green;
        // }
        // .span5{
        //     background: red;
        // }
      }

      .water1 {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        align-items: center;

        .wa_list {
          display: flex;
          height: 26px;
          flex: 1;

          span {
            display: inline-block;
            flex: 1;
            background: #ebeef5;
            line-height: 26px;
            text-align: center;
            color: #ebeef5;
          }

          :nth-of-type(1) {
            border-radius: 13px 0 0 13px;
          }

          :nth-of-type(4) {
            border-radius: 0 13px 13px 0;
          }

          .gr {
            background: #5cb87a;
            color: #5cb87a
          }

          .ye {
            background: #e6a23c;
            color: #e6a23c
          }

          .re {
            background: #f56c6c;
            color: #f56c6c
          }

          .bla {
            background: #7d7777;
          }

        }

        p {
          margin-left: 10px;
        }
      }

      .fault_info {
        flex: 1;

        .fault_bot {
          border-top: 1px solid #dcdcdc;
          border-left: 1px solid #dcdcdc;

          .bot_list {
            height: 45px;
            display: flex;
            border-right: 1px solid #dcdcdc;
            border-bottom: 1px solid #dcdcdc;
            line-height: 45px;

          }

          .bot_list div:nth-of-type(1) {

            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            text-align: center;

          }

          .tit {
            background: #01AAA7;
          }

          .bot_list div:nth-of-type(2) {

            font-size: 14px;
            text-align: center;
          }
        }
      }

      .ac_bot {
        display: flex;
        margin-bottom: 20px;

        .fault_bot {
          border-top: 1px solid #dcdcdc;
          border-left: 1px solid #dcdcdc;

          .bot_list {
            height: 45px;
            display: flex;
            border-right: 1px solid #dcdcdc;
            border-bottom: 1px solid #dcdcdc;
            line-height: 45px;

          }

          .bot_list div:nth-of-type(1) {

            color: #fff;
            font-size: 14px;
            font-family: Source Han Sans CN;
            text-align: center;

          }

          .tit {
            background: #01AAA7;
          }

          .bot_list div:nth-of-type(2) {

            font-size: 14px;
            text-align: center;
          }
        }
      }
    }

    .info_top {
      width: 100%;
      height: 40px;
      background: #E5F6F6;

      border: 1px solid #80D4D3;
      border-radius: 5px 5px 0px 0px;
      line-height: 40px;

      span {
        font-weight: 600;
        letter-spacing: 2px;
        margin-left: 5px;
        color: #01AAA7;
      }

      margin-bottom: 20px;
    }
  }

  .con {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .pagi {
    text-align: end;
    margin-top: 10px;
  }

  .searchinfo {
    margin-bottom: 15px;

    .handle-input {
      margin-right: 15px;
    }
  }
}
</style>
